import { render, staticRenderFns } from "./AlbumsRu.vue?vue&type=template&id=7db60106&"
import script from "./AlbumsRu.vue?vue&type=script&lang=js&"
export * from "./AlbumsRu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports